import React from "react";
import { Card, CardBody, Label } from "reactstrap";
import { FormLead } from "../../../../cores/facebookForm/interfaces/api/get-facebook-form";

interface Props {
  facebookFormLead: FormLead;
}

export default function LeadCard(props: Props) {
  const { facebookFormLead } = props;

  return (
    <Card
      key={facebookFormLead.id}
      className="neu-out align-content-center border-0 d-flex justify-content-center p-3"
    >
      <CardBody className="p-2 d-flex flex-column">
        { facebookFormLead.createdTime }
        <hr />
        {facebookFormLead.data.map((data) => (
          <Label key={data}>
            {data}
          </Label>
        ))}
      </CardBody>
    </Card>
  );
}
